


























import { Component, Vue } from "vue-property-decorator";
import db from "@/db";
import { namespace } from "vuex-class";
import DocumentData from "firebase";
@Component
export default class Admin extends Vue {
    users : any = [];

    created() {
        this.users = [];
        db.collection("roles")
          .get()
          .then(snap => {
            snap.forEach(doc => {
              const user = doc.data();
              user.id = doc.id;
              console.log(doc.data());
              //if (!user.role.admin) this.users.push(user);
              this.users.push(user);
            });
          });
    }
}
